import { render, staticRenderFns } from "./BetaZPlots.vue?vue&type=template&id=4e8884c8&"
import script from "./BetaZPlots.vue?vue&type=script&lang=js&"
export * from "./BetaZPlots.vue?vue&type=script&lang=js&"
import style0 from "./BetaZPlots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports